import { render, staticRenderFns } from "./TResizableHorizontalPanel.vue?vue&type=template&id=14127caf&scoped=true&"
import script from "./TResizableHorizontalPanel.vue?vue&type=script&lang=js&"
export * from "./TResizableHorizontalPanel.vue?vue&type=script&lang=js&"
import style0 from "./TResizableHorizontalPanel.vue?vue&type=style&index=0&id=14127caf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14127caf",
  null
  
)

export default component.exports